import { render, staticRenderFns } from "./Overtime.vue?vue&type=template&id=2fc39a5e&scoped=true"
import script from "./Overtime.vue?vue&type=script&lang=js"
export * from "./Overtime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc39a5e",
  null
  
)

export default component.exports